export default {
  data() {
    return {

    }
  },
  computed: {
    ENABLED_CRYPTO_ONLINE_BANK_DEPOSIT() {
      return process.env.VUE_APP_IS_ENABLED_CRYPTO_ONLINE_BANK_DEPOSIT === 'true'
    },
    ENABLED_CRYPTO_WIRE_BANK_DEPOSIT() {
      return process.env.VUE_APP_IS_ENABLED_CRYPTO_WIRE_BANK_DEPOSIT === 'true'
    },
    ENABLED_CRYPTO_MEMO_BANK_DEPOSIT() {
      return process.env.VUE_APP_IS_ENABLED_CRYPTO_MEMO_BANK_DEPOSIT === 'true'
    },
  },
}
